// @ts-strict-ignore
/** @jsx jsx */
import React from 'react'
import { jsx } from 'theme-ui'

import SchemaBasedClickOutLink from './schema-based'
import TransformBasedClickOutLink from './transform-based'

export default (props) => {
  if (props.schema && !props.transformation) {
    return <SchemaBasedClickOutLink {...props} />
  } else {
    return <TransformBasedClickOutLink {...props} />
  }
}
